import { koneOnlineHttp } from '@/utils/axios'
import { IProjectOverview, IUserInfo, PushSWitch } from '../types/koneOnline'

enum Api {
  info = '/v2/api/auth/user/info', // 用户信息
  hasBlockDoorPermission = '/v2/api/orderevent/hasBlockDoorPermission', // 检查是否存在停梯事件数据, true 显示停梯的设置switch, false 不显示
  projectOverview = '/v2/api/project/onlyProject', // 项目信息
  userProject = '/v2/api/auth/user/project', // 大屏分级
  getPushSwitch = '/v2/api/auth/user/getPushSwitch', // 通知开关设置查询
  groupExternalId = '/v2/api/wechatCall/groupExternalId' // 获取任意楼宇id
}

export const getUserInfo = () => koneOnlineHttp.get<IUserInfo>({ url: Api.info })
export const hasBlockDoorPermission = () =>
  koneOnlineHttp.get<boolean>({ url: Api.hasBlockDoorPermission })
// 获取所拥有的项目信息
export const getProjectOverview = async () => {
  const { projectVersionId, functionalLocationDescription } = await koneOnlineHttp.get<
    IProjectOverview['data']
  >({
    url: Api.projectOverview
  })
  return {
    isSingle: !!(projectVersionId && functionalLocationDescription),
    data: {
      projectVersionId,
      functionalLocationDescription
    }
  }
}

export const getUserProject = (params?: any) =>
  koneOnlineHttp.get<any>({ url: Api.userProject, params })

export const getPushSwitch = () => koneOnlineHttp.get<PushSWitch>({ url: Api.getPushSwitch })

// 获取任意楼宇id
// export const getGroupExternalId = () =>
//   koneOnlineHttp.get<{ externalId: string }>({ url: Api.groupExternalId })
